import { AppEdition, getCurrentAppEdition } from '@/shared/appEdition';

// Picks the implementation for the current AppEdition and forwards the call to it.
export const createEditionFormatter =
    <TArgs extends unknown[], TResult>(
        implementations: Record<AppEdition, (...args: TArgs) => TResult>,
    ) =>
    (...args: TArgs): TResult =>
        implementations[getCurrentAppEdition()](...args);
